/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { Suspense } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import { getCookie, getWindowLocationPath } from "./redux/constants";
import { setLoginStatus } from "./redux/actions/Auth";

import ErrorBoundary from "./ErrorBoundary";
import { ShareableComponent } from "./components/layout2/shareable/ShareableComponent";
import WidgetMaker from "./components/WidgetMaker";
import { onDashboardReset } from "./redux/actions/dashboard/Tab1";
import { setTemplateListType } from "./redux/actions/ApiCall/apiCall";
import { memo } from "react";

const HomePage = React.lazy(() => import("./components/layout2/Home"));
const LandingPage = React.lazy(() => import("./components/layout/LandingPage"));
const SessionExpired = React.lazy(() =>
  import("./components/sessionExpired/index")
);
//CHnages
const CommandCenter = React.lazy(() => import("./components/commandCenter"));
const PdfDownload = React.lazy(() =>
  import("./components/layout2/pdfdownload/PdfDownload")
);
const PDFGenerateStatus = React.lazy(() =>
  import("./components/layout2/pdfdownload/PdfGenerateStatus")
);

const Templates = React.lazy(() => import("./components/layout2/template"));
const TemplateHeader = React.lazy(() =>
  import("./components/layout2/template/TemplateHeader")
);
const WidgetLibrary = React.lazy(() =>
  import("./components/WidgetLibrary/index")
);
const Routes = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [redirectPath, setredirectPath] = useState("/explore");
  const [flag, setflag] = useState(false);
  const [path] = useState(window.location.pathname);
  const auth = useSelector((state) => state.Authentication.auth);
  const authParams = useSelector((state) => state.Authentication.authParams);
  const loginStatus = useSelector((state) => state.Authentication.loginStatus);
  const downloadId = useSelector((state) => state.ApiCall.downloadId);
  const pdfGenerateStatus = useSelector(
    (state) => state.ApiCall.pdfGenerateStatus
  );
  const pinnedTemplateListData = useSelector(
    (state) => state?.ApiCall?.pinnedTemplateListData
  );
  let ptoken = getCookie("ptoken");
  let user_id = getCookie("userid");

  var urlParams; // url encrypted parameters

  //Function to get url params from URL and set it to urlParams variable
  (window.onpopstate = function () {
    var match,
      pl = /\+/g, // Regex for replacing addition symbol with a space
      search = /([^&=]+)=?([^&]*)/g,
      decode = function (s) {
        return decodeURIComponent(s.replace(pl, " "));
      },
      query = window.location.search.substring(1);

    urlParams = {};
    while ((match = search.exec(query)))
      urlParams[decode(match[1])] = decode(match[2]);
  })();

  useEffect(() => {
    let path = window.location.pathname;
    let condition =
      path !== "/explore" ||
      path !== "/dashboard" ||
      path !== "/workspace" ||
      path !== "/activate" ||
      path !== "/templates" ||
      path !== "/socailchannel" ||
      path !== "/share" ||
      path !== "/download" ||
      path !== "/ticket" ||
      path !== "/analytics_listening" ||
      path !== "/activate" ||
      path !== "/edit-dashboard/:id" ||
      path !== "/edit-widget/:id" ||
      path !== "/widgetMaker" ||
      path !== "/schedule" ||
      path !== "/all-dashboard" ||
      path !== "/pin-dashboard";

    if (!condition) {
      setflag(true);
    }

    if (path == "/") {
      if (urlParams?.ptoken && urlParams?.userid) {
        // let params = {
        //   ptoken: urlParams?.ptoken,
        //   userid: parseInt(urlParams?.userid),
        // };

        setredirectPath("/dashboard");
      } else if (ptoken && user_id) {
        setredirectPath("/dashboard");
      } else {
        setredirectPath("/explore");
      }
    }
    // else if (path === "/widgetMaker") {

    // 	isDuplicate && setredirectPath("/edit-widget/");
    // }

    if (path == "/explore") {
      if (
        (ptoken && user_id && !loginStatus) ||
        (auth?.data?.result?.user_id &&
          auth?.data?.result?.ptoken &&
          !loginStatus)
      ) {
        dispatch(setLoginStatus(ptoken, user_id));
      }
    }

    if (path == "/dashboard" && ptoken === "" && !urlParams?.ptoken) {
      document.location.href = "/explore";
    }
    if (path == "/all-dashboard") {
      window.localStorage.clear();
      dispatch(onDashboardReset());
    }
    if (path == "/pin-dashboard") {
      // PIN DEV if we clear panes, we cant perform download ppt
      // in case of ppt dont clear panes
      if (!urlParams?.ppt && !pinnedTemplateListData) {
        window.localStorage.clear();
        dispatch(onDashboardReset());
      }
    }
    if (path == "/dashboard" && urlParams?.ptoken && urlParams?.template_id) {
      dispatch(onDashboardReset());
    }
    if (path == "/widgetMaker" && ptoken === "" && !urlParams?.ptoken) {
      document.location.href = "/explore";
    }
    if (path === "/schedule") {
      dispatch(setTemplateListType("report"));
    } else {
      dispatch(setTemplateListType("dashboard"));
    }
  }, [path]);

  useEffect(() => {
    if (
      loginStatus?.data?.result?.logged_in &&
      getWindowLocationPath()?.toLowerCase() !== "CommandCenter"?.toLowerCase()
    ) {
      document.location.href = "/dashboard";
    }
  }, [loginStatus]);

  useEffect(() => {
    if (downloadId) {
      history.push(`/download?pdf_id=${downloadId?.id}`);
    }
  }, [downloadId]);

  if (!flag)
    return (
      <Switch>
        <Route path="/CommandCenter">
          <Suspense
            fallback={
              <div
                className="d-flex align-items-center"
                style={{
                  justifyContent: "space-evenly",
                  height: "calc(100vh - 4rem)",
                }}
              >
                <div className="lds-ring">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            }
          >
            <ErrorBoundary>
              <CommandCenter urlParams={{ ...urlParams }} />
            </ErrorBoundary>
          </Suspense>
        </Route>
        <Route exact path="/sessionexpired">
          <Suspense
            fallback={
              <div
                className="d-flex align-items-center"
                style={{
                  justifyContent: "space-evenly",
                  height: "calc(100vh - 4rem)",
                }}
              >
                <div className="lds-ring">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            }
          >
            <ErrorBoundary>
              <SessionExpired />
            </ErrorBoundary>
          </Suspense>
        </Route>
        <Route exact path="/templates">
          <Suspense
            fallback={
              <div
                className="d-flex align-items-center"
                style={{
                  justifyContent: "space-evenly",
                  height: "calc(100vh - 4rem)",
                }}
              >
                <div className="lds-ring">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            }
          >
            <ErrorBoundary>
              <Templates />
              {pdfGenerateStatus && <PDFGenerateStatus />}
            </ErrorBoundary>
          </Suspense>
        </Route>
        <Route exact path="/create-dashboard">
          <Suspense
            fallback={
              <div
                className="d-flex align-items-center"
                style={{
                  justifyContent: "space-evenly",
                  height: "calc(100vh - 4rem)",
                }}
              >
                <div className="lds-ring">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            }
          >
            <ErrorBoundary>
              <TemplateHeader edit={false} />
            </ErrorBoundary>
          </Suspense>
        </Route>
        <Route exact path="/edit-dashboard/:id">
          <Suspense
            fallback={
              <div
                className="d-flex align-items-center"
                style={{
                  justifyContent: "space-evenly",
                  height: "calc(100vh - 4rem)",
                }}
              >
                <div className="lds-ring">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            }
          >
            <ErrorBoundary>
              <TemplateHeader edit={true} />
            </ErrorBoundary>
          </Suspense>
        </Route>
        <Route exact path="/workspace">
          <Suspense
            fallback={
              <div
                className="d-flex align-items-center"
                style={{
                  justifyContent: "space-evenly",
                  height: "calc(100vh - 4rem)",
                }}
              >
                <div className="lds-ring">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            }
          >
            <ErrorBoundary>
              {pdfGenerateStatus && <PDFGenerateStatus />}
            </ErrorBoundary>
          </Suspense>
        </Route>
        <Route exact path="/explore">
          <Suspense
            fallback={
              <div
                className="d-flex align-items-center"
                style={{
                  justifyContent: "space-evenly",
                  height: "calc(100vh - 4rem)",
                }}
              >
                <div className="lds-ring">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            }
          >
            <ErrorBoundary>
              <LandingPage />
            </ErrorBoundary>
          </Suspense>
        </Route>

        <Route exact path="/dashboard">
          <Suspense
            fallback={
              <div
                className="d-flex align-items-center"
                style={{
                  justifyContent: "space-evenly",
                  height: "calc(100vh - 4rem)",
                }}
              >
                <div className="lds-ring">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            }
          >
            <ErrorBoundary>
              <HomePage />
            </ErrorBoundary>
            {pdfGenerateStatus && (
              <ErrorBoundary>
                <PDFGenerateStatus />
              </ErrorBoundary>
            )}
          </Suspense>
        </Route>
        <Route exact path="/all-dashboard">
          <Suspense
            fallback={
              <div
                className="d-flex align-items-center"
                style={{
                  justifyContent: "space-evenly",
                  height: "calc(100vh - 4rem)",
                }}
              >
                <div className="lds-ring">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            }
          >
            <ErrorBoundary>
              <HomePage />
            </ErrorBoundary>

            {pdfGenerateStatus && (
              <ErrorBoundary>
                <PDFGenerateStatus />
              </ErrorBoundary>
            )}
          </Suspense>
        </Route>
        <Route exact path="/pin-dashboard">
          <Suspense
            fallback={
              <div
                className="d-flex align-items-center"
                style={{
                  justifyContent: "space-evenly",
                  height: "calc(100vh - 4rem)",
                }}
              >
                <div className="lds-ring">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            }
          >
            <ErrorBoundary>
              <HomePage />
            </ErrorBoundary>

            {pdfGenerateStatus && (
              <ErrorBoundary>
                <PDFGenerateStatus />
              </ErrorBoundary>
            )}
          </Suspense>
        </Route>

        <Route exact path="/share">
          <ErrorBoundary>
            <ShareableComponent />
          </ErrorBoundary>
        </Route>

        <Route exact path="/download">
          <Suspense
            fallback={
              <div
                className="d-flex align-items-center"
                style={{
                  justifyContent: "space-evenly",
                  height: "calc(100vh - 4rem)",
                }}
              >
                <div className="lds-ring">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            }
          >
            <ErrorBoundary>
              <PdfDownload />
            </ErrorBoundary>
          </Suspense>
        </Route>
        <Route exact path="/widgetMaker">
          <Suspense
            fallback={
              <div
                className="d-flex align-items-center"
                style={{
                  justifyContent: "space-evenly",
                  height: "calc(100vh - 4rem)",
                }}
              >
                <div className="lds-ring">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            }
          >
            <ErrorBoundary>
              <WidgetLibrary />
            </ErrorBoundary>
          </Suspense>
        </Route>
        <Route exact path="/schedule">
          <Suspense
            fallback={
              <div
                className="d-flex align-items-center"
                style={{
                  justifyContent: "space-evenly",
                  height: "calc(100vh - 4rem)",
                }}
              >
                <div className="lds-ring">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            }
          >
            <ErrorBoundary>
              <HomePage />
            </ErrorBoundary>
          </Suspense>
        </Route>
        <Route exact path="/edit-widget/:id">
          <Suspense
            fallback={
              <div
                className="d-flex align-items-center"
                style={{
                  justifyContent: "space-evenly",
                  height: "calc(100vh - 4rem)",
                }}
              >
                <div className="lds-ring">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            }
          >
            <ErrorBoundary>
              <WidgetMaker />
            </ErrorBoundary>
          </Suspense>
        </Route>
        <Route exact path={path}>
          <Redirect to={redirectPath} />
        </Route>
      </Switch>
    );
};

export default memo(Routes);
